import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useEspace } from '../../contexts/EspaceContext';
import { EspaceSidebar } from './EspaceSidebar';

/**
 * Ajoute la barre latérale de « Mon espace » autour du contenu des modules,
 * sans rien changer aux pages elles-mêmes.
 */
export function EspaceLayout({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    inEspace,
    exitEspace
  } = useEspace();
  const {
    pathname
  } = useLocation();

  // Revenir à l'accueil du site quitte l'espace citoyen.
  useEffect(() => {
    if (pathname === '/') exitEspace();
  }, [pathname, exitEspace]);
  if (!inEspace) return <>{children}</>;
  return <div className="flex w-full items-stretch" data-id="element-1403" data-mp="1awswqpe4sowr">
      <EspaceSidebar data-id="element-1404" data-mp="1ewjlknk3kuyn" />
      <div className="min-w-0 flex-1" data-id="element-1405" data-mp="1evrzq4gayblk">{children}</div>
    </div>;
}